<!--
 * @Author: wumao
 * @Date: 2021-11-24 16:15:02
 * @LastEditors: yeqing
 * @LastEditTime: 2022-05-13 16:26:56
 * @Description: 第一页
-->
<template>
  <Page page="03" :companyName="resultData.orgName">
    <div class="wrapper">
      <div class="item">
        <Title text="海南省专精特新中小企业分布情况" />
        <div class="info">
          <div class="pie" ref="pie1"></div>
          <div class="pie" ref="pie2"></div>
          <div class="pie" ref="pie3"></div>
        </div>
        <div class="desc" style="margin-top: 40px;">
          海南省相关“专精特新”企业分为两类：包括海南省“专精特新”
          中小企业、海南省国家专精特新“小巨人”企业。以上资格需要在相关政府部门进行资格认定，获得认定资格的企业将享受国家和地方在资金补贴、上市扶持、融资便利等一系列的优惠政策。对国家级专精特新“小巨人”企业，可获得最高
          50
          万元奖励，还可以根据不同的项目申报扶持补助，获得补助数额最高达数千万元。
        </div>
        <div class="desc">
          企业要取得“专精特新”企业资格，要在知识产权、主营业务收入、研发费用、各项财务指标、各类资质认定，荣誉等各方面满足相关的要求。
        </div>
      </div>
    </div>
  </Page>
</template>

<script>
import Page from "./Page.vue";
import Title from "./Title.vue";
import * as echarts from "echarts";

const pieOptions1 = {
  // color: ['#5acbb8', '#5b8ff9', '#657798'],
  title: {
    text: "专精特新中小企业行业分布占比",
    left: "center",
    bottom: "60",
    textStyle: {
      fontSize: 13,
    },
  },
  tooltip: {
    trigger: "item",
  },
  grid: {
    top: 0,
  },
  legend: {
    // right: "right",
    bottom:'20',
    itemHeight: 7,
    itemWidth: 7,
    textStyle: {
      fontSize: 9,
    },
  },
  series: [
    {
      type: "pie",
      radius: ["30%", "60%"],
      center: ["52%", "33%"],
      labelLine: {
        show: true,
        length: 10,
        length2: 0,
      },
      label: {
        formatter: "{b} {d}%",
        fontSize: 11,
      },
      data: [
        { value: 26, name: "医药制造业" },
        { value: 15, name: "软件和信息技术服务业" },
        { value: 14, name: "批发业" },
        { value: 10, name: "互联网和相关服务" },
        { value: 9, name: "专业技术服务业" },
        { value: 7, name: "科技推广和应用服务业" },
        { value: 7, name: "零售业" },
        { value: 6, name: "非金属矿物制品业" },
        { value: 5, name: "生态保护和环境治理业" },
        { value: 4, name: "信息传输、软件和信息技术服务业" },
        { value: 36, name: "其他" },
      ],
    },
  ],
};
const pieOptions2 = {
  // color: ['#5acbb8', '#5b8ff9', '#657798'],
  title: {
    text: "专精特新中小企业参保人员占比",
    left: "center",
    bottom: "60",
    textStyle: {
      fontSize: 13,
    },
  },
  tooltip: {
    trigger: "item",
  },
  grid: {
    top: 0,
  },
  legend: {
    // right: "right",
    bottom:'40',
    itemHeight: 7,
    itemWidth: 7,
    textStyle: {
      fontSize: 9,
    },
  },
  series: [
    {
      type: "pie",
      radius: ["30%", "60%"],
      center: ["52%", "33%"],
      labelLine: {
        show: true,
        length: 10,
        length2: 0,
      },
      label: {
        formatter: "{b} {d}%",
        fontSize: 11,
      },
      data: [
        { value: 37, name: "0≤x<20" },
        { value: 40, name: "20≤x<50" },
        { value: 27, name: "50≤x<100" },
        { value: 15, name: "100≤x<200" },
        { value: 19, name: "200≤x" },
      ],
    },
  ],
};
const pieOptions3 = {
  // color: ['#5acbb8', '#5b8ff9', '#657798'],
  title: {
    text: "专精特新中小企业类型占比",
    left: "center",
    bottom: "60",
    textStyle: {
      fontSize: 13,
    },
  },
  tooltip: {
    trigger: "item",
  },
  grid: {
    top: 0,
  },
  legend: {
    // right: "right",
    bottom: "bottom",
    itemHeight: 7,
    itemWidth: 7,
    textStyle: {
      fontSize: 9,
    },
  },
  series: [
    {
      type: "pie",
      radius: ["30%", "60%"],
      center: ["52%", "35%"],
      labelLine: {
        show: true,
        length: 10,
        length2: 0
      },
      label: {
        formatter: "{b}{d}%",
        fontSize: 11,
      },
      data: [
        { value: 42, name: "有限责任公司(自然人投资或控股)" },
        { value: 31, name: "其他有限责任公司" },
        { value: 22, name: "有限责任公司(非自然人投资或控股的法人独资)" },
        { value: 17, name: "股份有限公司(非上市、自然人投资或控股)" },
        { value: 9, name: "有限责任公司(自然人投资或控股的法人独资)" },
        { value: 3, name: "其他股份有限公司(非上市)" },
        { value: 3, name: "有限责任公司(港澳台法人独资）" },
        { value: 2, name: "有限责任公司(港澳台投资、非独资)" },
        { value: 2, name: "有限责任公司(自然人独资)" },
        { value: 1, name: "有限责任公司(台港澳与境内合资)" },
        { value: 6, name: "其他" },
      ],
    },
  ],
};
export default {
  props: {
    resultData: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    Page,
    Title,
  },

  mounted() {
    this.initChart();
  },
  methods: {
    initChart() {
      let myChart1 = echarts.init(this.$refs.pie1);
      pieOptions1 && myChart1.setOption(pieOptions1);

      let myChart2 = echarts.init(this.$refs.pie2);
      pieOptions2 && myChart2.setOption(pieOptions2);

      let myChart3 = echarts.init(this.$refs.pie3);
      pieOptions3 && myChart3.setOption(pieOptions3);
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  .item {
    font-size: 14px;
    color: #333;
    margin-bottom: 30px;
    .pie {
      width: 700px;
      height: 300px;
      margin: 0 auto;
      margin-bottom: 20px;
    }
    .info {
      margin-top: 40px;
    }
    .desc {
      margin-left: 20px;
      line-height: 20px;
      color: #666666;
      font-size: 10px;
    }
  }
}
</style>
